// @flow

import * as React from "react";

export type MenuContextState = {
    isMobile: boolean,
};

const MenuContext: React$Context<MenuContextState> = React.createContext<MenuContextState>({
    isMobile: false,
});

export default MenuContext;
